import { authorSearchConstants } from '../constants';
import myFetchWithId from '.././helpers/myFetch';
import { timestampConverter,timestampTOstringDate } from '../components/channelSearch/channelHelper';

export function getDay(sDate,eDate){
    return{
        type:authorSearchConstants.GET_DAY,
        sDate:sDate,
        eDate:eDate,
    }
}

export function setAllDocs(alldocs){
    return {
        type:authorSearchConstants.SET_DOCS,
        alldocs:alldocs,
    }
}

export function fetchAuthor(name,sdate,edate){
    return dispatch => {
        dispatch(requestAuthorSearch())
        return myFetchWithId('', true, true)('/v5/lowi3/s/author', {author_name:name,sdate:sdate,edate:edate})
        .then(json => dispatch(receiveAuthorSearch(json,sdate,edate)))
        .catch(err => {console.log(err)})
      };
}

function requestAuthorSearch (){
    return{
        type:authorSearchConstants.REQUEST_AUTHOR,
        receivedAt: Date.now(),
    }
}

function receiveAuthorSearch(json,sdate,edate){
    const allAuthors =[]
    const allSource=[]
    json.value.forEach(item =>{
        allSource.push(item.GLB_SOURCE)
        allAuthors.push(...item.field)
    })
    return{
        type:authorSearchConstants.RECEIVE_AUTHOR,
        allAuthors:allAuthors,
        allSource:allSource,
        sdate:sdate,
        edate:edate,
        searchData:json.value,
        receivedAt: Date.now(),
    }
}

export function authorSunburst(authorKey,sdate,edate){
    return dispatch => {
        dispatch(requestSunburst())
        return myFetchWithId('', true, true)('/v5/lowi3/s/author_sunburst', {glb_author_key:authorKey,sdate:sdate,edate:edate})
        .then(json => dispatch(receiveSunburst(json,sdate,edate)))
        .catch(err => {console.log(err)})
    };
}

function requestSunburst(){
    return{
        type:authorSearchConstants.REQUEAT_SUNBURST,
        receivedAt: Date.now(),
    }
}

function receiveSunburst(json,sdate,edate){
    
    console.log(json)

    const sunburstData = [
        {id: '0.0',parent: '',name: '文章總量'},
        {id: '1.1',parent: '0.0',name: '主文',color:'#868e96'},
        {id:'1.2',parent:'0.0',name:'回文',color:'#525252'},
      ]

    json.value.forEach(item=>{
        let sentiment = item.status.substring(2,4)
        switch (sentiment) {
            case '負向':
                item['color'] = '#DA4453'
                break;
            case '中立':
                item['color'] = '#37BC9B'
                break;
            case '正向':
                item['color'] = '#5e9cec'
                break;
            default:
                break;
        }
        let lv2 = {
            id:item.parent,
            parent:item.status.substring(0,2) === '主文' ? '1.1' : '1.2',
            name:item.status,
            value:item.children.length,
            color:item.color,
        }
        sunburstData.push(lv2)
        // item.children.forEach(obj=>{
        //     obj['parent']=item.parent
        //     obj['value']=1
        //     obj['score']=item.score
        //     sunburstData.push(obj)
        // })
    })

    console.log(sunburstData)

    return{
        type:authorSearchConstants.RECEIVE_SUNBURST,
        sunburstData:sunburstData,
        value:json.value,
        sdate:sdate,
        edate:edate,
        receivedAt: Date.now(),
    }
}

export function switchSearchType(type) {
    return {
      type:authorSearchConstants.SWITCH_TYPE,
      searchType:type,
    }
  }

export function analysisAuthor(authorKey,sdate,edate,author){
    // let docsParam ={
    //     text: keyword,
    //     page: page,
    //     score: '3',
    //     items: 30,
    //     authorKey:authorKey, //在作者查詢 call qdocs 的條件
    //   };
    // console.log(author)

    let params = {
        text: '*',
        page: 1,
        score: '3',
        items: 10000,
        authorKey:authorKey,
        glb_posttype: 'P',
        glb_sentiment: '',
        sorts:'',
        sdate:sdate,
        edate:edate,
    };
    return dispatch => {
        dispatch(requestAnalysis())
        return Promise.all([
            myFetchWithId('', true, true)('/v5/lowi3/s/author_top15ch', {glb_author_key:authorKey,sdate:sdate,edate:edate}),
            myFetchWithId('012', false, true)(`${process.env.REACT_APP_API}/q/qdocs`, params)
            // myFetchWithId('', true, true)('v5/lowi3/s/author_category_1', {glb_author_key:authorKey,sdate:sdate,edate:edate}),
            // myFetchWithId('', true, true)('v5/lowi3/s/author_category_2', {glb_author_key:authorKey,sdate:sdate,edate:edate}),
        ])
        .then(json => dispatch(receiveAnalysisData(json,sdate,edate)))
        .catch(err => {console.log(err)})
      };
}

function requestAnalysis (){
    return{
        type:authorSearchConstants.REQUEST_AUTHOR_ANALYSIS,
        receivedAt: Date.now(),
    }
}

function receiveAnalysisData(json,sdate,edate){
    let status = ''

    console.log(json)

    let bableChartData = Object.values(json[1].docs.docs).map(item=>{
        let score =  parseInt(json[1].docs.lowiscore[item.DREREFERENCE]['$'])
        let dateTimeStamp = parseInt(timestampConverter(item.GLBTIME_YMD))

        return { 
            x: dateTimeStamp, 
            y: parseInt(item.GLBTIME_YMDH.substring(8,10)), 
            z:score+5,
            date:timestampTOstringDate(dateTimeStamp) ,
            name: item.DRETITLE ,
            dre:item.DREREFERENCE,
            content:item.DRECONTENT,
            comment:item.GLBNUM_COMMENTCOUNT,
            like:item.GLBNUM_LIKECOUNT,
            share:item.GLBNUM_SHARECOUNT,
            score:score 
        }
    })

    // const categoryChart1 = {xAxis:[],count:[],spline:[],errorbar:[],drereference:[]}
    // const categoryChart2 = {xAxis:[],count:[],spline:[],errorbar:[],drereference:[]}

    // json.forEach((item,index)=>{
    //     item.code ? status = item.code : status = "SUCCESS"
        // if(index === 1 || index === 2){
        //     let array = Object.values(item.value[0])
        //     if(index===1){
        //         categoryChart1.xAxis = Object.keys(item.value[0])
        //         array.forEach(item=>{
        //             let errorBar = [item.weight_min,item.weight_max]
        //             categoryChart1.count.push(item.count)
        //             categoryChart1.errorbar.push(errorBar)
        //             categoryChart1.spline.push(item.weight_avg)
        //             categoryChart1.drereference.push(item.drereference)
        //         })
        //     }
        //     else{
        //         categoryChart2.xAxis = Object.keys(item.value[0])
        //         array.forEach(item=>{
        //             let errorBar = [item.weight_min,item.weight_max]
        //             categoryChart2.count.push(item.count)
        //             categoryChart2.errorbar.push(errorBar)
        //             categoryChart2.spline.push(item.weight_avg)
        //             categoryChart2.drereference.push(item.drereference)
        //         })
        //     }
        // }
    // })

    return{
        type:authorSearchConstants.RECEIVE_AUTHOR_ANALYSIS,
        status:status,
        topCh:json[0].value,
        bableChartData:bableChartData,
        // categoryChart1:categoryChart1,
        // categoryChart2:categoryChart2,
        sdate:sdate,
        edate:edate,
        receivedAt: Date.now(),
    }
}


// WEBPACK FOOTER //
// ./src/actions/authorSearch.action.js